import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Text } from 'components/base'
import SelectRole from 'components/Utils/SelectRole'
import Confirm from 'components/Utils/Modal/Confirm'

import {
  selectors as UsersSelectors,
  actions as UsersActions,
} from 'data/users'

import { selectors as ConfigSelectors } from 'data/config'

const ROLES = {
  member: {
    title: 'Member',
    description:
      'By default, members can invite new members but can’t manage other members’ roles or rights.',
  },
  billingAdmin: {
    title: 'Billing Admin',
    description:
      'Like regular members but with the ability to manage the billing setup.',
  },
  admin: {
    title: 'Admin',
    description:
      'Admins can invite new team members and manage all members’ roles and rights.',
  },
}

const GUEST_ROLE = {
  guest: {
    title: 'Guest',
    description:
      'Guest do not have access to public channel or any channel by default, cannot invite people or share docs publicly.',
  },
}

const OWNER_ROLE = {
  owner: {
    title: 'Owner',
    description: 'Owner manages all team preferences.',
  },
}

class SelectOrganizationRole extends Component {
  state = {
    showConfirm: false,
  }

  onConfirm = () => {
    this.props.setUserAsOwner({ userId: this.props.user.id })
    this.setState({ showConfirm: false })
  }
  onCancel = () => {
    this.setState({ showConfirm: false })
  }
  render() {
    const {
      user,
      canManage,
      updateState,
      updateUserOrganizationRole,
      popoverPlacement,
      currentUser,
      canSetRoleAsGuest,
      defaultRoles = ROLES,
    } = this.props

    if (!canManage || user.organizationRole === 'owner') {
      return (
        <div
          className="text-align-left bold shade-10"
          style={{ height: 30, lineHeight: '30px', minWidth: 120 }}
        >
          {user.organizationRole}
        </div>
      )
    }
    let roles = defaultRoles
    if (currentUser && currentUser.organizationRole === 'owner') {
      roles = Object.assign({}, roles, OWNER_ROLE)
    }
    if (canSetRoleAsGuest) {
      roles = Object.assign({}, roles, GUEST_ROLE)
    }

    return (
      <div className="position-relative">
        <SelectRole
          currentRole={user.get('organizationRole')}
          roles={roles}
          onSelectRole={role => {
            if (role === 'owner') {
              this.setState({ showConfirm: true })
            } else {
              updateUserOrganizationRole(user.get('id'), role)
            }
          }}
          popoverPlacement={popoverPlacement}
        />
        {updateState &&
          updateState.get('error') && (
            <div>{updateState.get('error').get('message')}</div>
          )}

        <Confirm
          show={this.state.showConfirm}
          onConfirm={this.onConfirm}
          onCancel={this.onCancel}
          confirmLabel={'Confirm transfer'}
          width={500}
        >
          <Text.Title className="margin-bottom-large line-height-normal">
            Are you sure you want to transfer your ownership?
          </Text.Title>
          <div className="text-align-left shade-10">
            You’re about to transfer your team ownership to another member.
            You’ll be downgraded from Team Owner to Team Admin. This action will
            be immediate.{' '}
            <Text.ExternalLink
              target="_blank"
              rel="noopener noreferrer"
              href="https://help.slite.com/slite-features-guide/collaboration-guide/slite-team-roles"
            >
              Read more about roles in Slite
            </Text.ExternalLink>
            .
          </div>
        </Confirm>
      </div>
    )
  }
}

const mapStateToProps = (state, { user }) => ({
  canSetRoleAsGuest: ConfigSelectors.hasFlag(state, 'guest-role'),
  currentUser: UsersSelectors.getCurrentUser(state),
  canManage: UsersSelectors.canCurrentUserManageOrganization(state),
  updateState: UsersSelectors.getUpdateOrganizationRoleState(state).get(
    user.get('id')
  ),
})

const mapDispatchToProps = {
  updateUserOrganizationRole: UsersActions.updateUserOrganizationRole,
  setUserAsOwner: UsersActions.setUserAsOwner,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectOrganizationRole)
